/**
 * Persists End Overdose app user id (?userId=) across store navigation.
 */
(function () {
  const EO_USER_ID_KEY = 'eo_userId';

  function captureEoUserIdFromUrl() {
    const id = new URLSearchParams(window.location.search).get('userId');
    if (!id) return;
    try {
      sessionStorage.setItem(EO_USER_ID_KEY, id);
    } catch (e) {
      /* sessionStorage unavailable */
    }
  }

  function getEoUserId() {
    const fromUrl = new URLSearchParams(window.location.search).get('userId');
    if (fromUrl) return fromUrl;
    try {
      return sessionStorage.getItem(EO_USER_ID_KEY) || '';
    } catch (e) {
      return '';
    }
  }

  captureEoUserIdFromUrl();

  window.EOUserId = {
    captureEoUserIdFromUrl: captureEoUserIdFromUrl,
    getEoUserId: getEoUserId,
  };
})();
